import { render, staticRenderFns } from "./PersonnelRecordSkillSet.vue?vue&type=template&id=2858dbf2"
import script from "./PersonnelRecordSkillSet.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordSkillSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports